export default __webpack_public_path__ + "static/media/pin-location-icon.3b4892c3.svg";